export const enums = {
        address:"https://official.juhaowu.cn",
        // banner 视频
        atoscnMp4:"https://image.juhaowu.cn/cn_video/video/twatos-cn.mp4",
        atoscnMp4480: "https://image.juhaowu.cn/cn_video/video/twatoshi-480p.mp4",
        atoscnMp4720: "https://image.juhaowu.cn/cn_video/video/twatoshi-720p.mp4",
        atoscnMp41080: "https://image.juhaowu.cn/cn_video/video/twatoshi-1080p.mp4",
        // 廖总及项目介绍
        ceoAtoscnMp4: "https://image.juhaowu.cn/cn_video/video/TWATOSHI.mp4",
        ceoAtoscnMp4480: "https://image.juhaowu.cn/cn_video/video/TWATOSHI480p.mp4",
        ceoAtoscnMp4720: "https://image.juhaowu.cn/cn_video/video/TWATOSHI720p.mp4",
        ceoAtoscnMp41080: "https://image.juhaowu.cn/cn_video/video/TWATOSHI1080p.mp4",
        ceoAtoscnVideoImg: "https://image.juhaowu.cn/cn_video/video/TWATOSHICOVER.jpg",
        // 正式 扩大百倍
        downloadUrl:"https://share-plus.juhaowu.net/#/xiazaiye?from=singlemessage",
        // 测试
        // downloadUrl:"http://appone.libangtianbo.net.cn/#/xiazaiye",
        // h5 下载海外版 正式
        seaAtoshiDownloadUrl:"https://www.atoshi.org/globaldownload/#/?language=zh-tw&timestamp=" + new Date().getTime(),
        // h5 下载海外版 测试
        // seaAtoshiDownloadUrl:"http://aboard-h5-test.juhaowu.cn/#/download",
        // 乐唰下载
        leshuaDownload:"https://leshua.info",
        // 游戏下载
        gamesDownload:"https://game-img.atoshi.mobi/official/box_mobile.jpg",
        judgeIp:"https://aggshop.juhaowu.cn/intbaseapi/base/ipFrom",
        // 区块链地址
        seaAtoshiChainUrl:"https://scan.atoverse.info",
        // 钱包地址
        walletUrl: "https://wallet.atoshi.org",
        // 原宇宙
        metatUrl: "https://meta.libangbo.cn/",
        // 密码箱
        keyUrl: "https://www.atoshikey.com/#/",
        // 小原子早晚安
        miniDaily: "https://inviteh5.bohongyu.online/download",
        // 原子链AI
        atoshiAI: "https://open.weixin.qq.com/qr/code?username=gh_a64d66abe4b5",
        // uniswap币币兑换链接
        uniswapUrl: "https://app.uniswap.org/swap?use=V2&inputCurrency=USDT&outputCurrency=0x4d0528598f916fd1d8dc80e5f54a8feedcfd4b18",
        // 乐唰url
        lsUrl: "https://www.atoshi.info/leshua/#/",
        // telgramUrl
        telgramUrl: "https://t.me/atoshiofficial",
        detokUrl:"https://www.atoshi.info/detok/#/",

        imgURLCommon:"https://video2.juhaowu.cn/static-web/mobile_img/common/img",
        imgURLZh1: "https://video2.juhaowu.cn/static-web/pc_zh1",
        imgURLTw1: "https://video2.juhaowu.cn/static-web/pc_tw1",
    };




// WEBPACK FOOTER //
// ./src/enum.js